import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { MixpanelService } from './mixpanel.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingStateService {
  private history = [];

  constructor(
    private router: Router,
 
  ) {}

  public loadRouting(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe({
        next: ({urlAfterRedirects}: NavigationEnd) => {
          this.history = [...this.history, urlAfterRedirects];
           // <-- Track page view
        }
      });
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(defaultUrl: string, forceDefault?: boolean): string {
    if(forceDefault) return defaultUrl;
    return this.history[this.history.length - 2] || defaultUrl;
  }
}